import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, retry, timer, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);

  return next(req).pipe(
    // P2-12: Retry GET requests up to 3 times on 5xx (502/503 included) or
    // network errors, with exponential backoff (1s, 2s, 4s). Non-GET and 4xx
    // errors are NOT retried (they are semantic, not transient).
    retry({
      count: req.method === 'GET' ? 3 : 0,
      delay: (error: HttpErrorResponse, retryCount: number) => {
        if (error.status === 0 || error.status >= 500) {
          const delayMs = Math.min(1000 * Math.pow(2, retryCount - 1), 4000);
          return timer(delayMs);
        }
        return throwError(() => error);
      },
    }),
    catchError((error: HttpErrorResponse) => {
      // Don't toast on 401 — handled by auth interceptor
      if (error.status === 401) {
        return throwError(() => error);
      }

      if (error.status === 0) {
        toast.error('Network error — check your connection');
      } else if (error.status === 403) {
        toast.error('Access denied');
      } else if (error.status === 429) {
        toast.warning('Too many requests — please slow down');
      } else if (error.status >= 500) {
        toast.error('Server error — please try again later');
      }

      return throwError(() => error);
    }),
  );
};
